module.exports = __webpack_public_path__ + "static/media/HBE-BE-logo.44c31a29.png";